import { createFileRoute } from "@tanstack/react-router";

import DashboardModule from "../../lib/modules/Dashboard/Dashboard.module";

const App = () => {
  return <DashboardModule />;
};

export const Route = createFileRoute("/app/")({
  staticData: {
    pageTitle: "Dashboard",
  },
  component: App,
});
